import { useBaseStationsStore } from '@/stores/baseStations';
import { useLicenseStore } from '@/stores/licenseStore';
import { MAP_MODE } from '@/components/map/consts/mapFeatureConsts';


type BaseStationsStore = ReturnType<typeof useBaseStationsStore>;
type LicenseStore = ReturnType<typeof useLicenseStore>;

const CNET_CONSTRUCTOR_ROUTES = ['cnet-constructor', 'cnet-constructor-add', 'cnet-constructor-edit'];

const applyRouteMapMode = (
	toName: string,
	fromName: string | undefined,
	baseStationsStore: BaseStationsStore,
	licenseStore: LicenseStore,
): void => {
	if (CNET_CONSTRUCTOR_ROUTES.includes(toName)) {
		baseStationsStore.setMode(MAP_MODE.cnetConstructor);
	} else if (toName === 'rovers' && licenseStore.featureFlagDashboard) {
		baseStationsStore.setMode(MAP_MODE.roversHistory);
	} else if (
		fromName != null
		&& (CNET_CONSTRUCTOR_ROUTES.includes(fromName) || fromName === 'rovers')
	) {
		baseStationsStore.setMode(MAP_MODE.main);
	}
};

export {
	applyRouteMapMode,
};
